import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormArrayGroupModule } from '@shared/components/form-array-group/form-array-group.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MapModule } from '@shared/components/map/map.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { ImpairedInputModule } from '@impairedShared/impaired-input/impaired-input.module';
import { PxModule } from '@shared/pipes/px/px.module';
import { CaptchaModule } from '@shared/components/captcha/captcha.module';
import { AppealsRoutingModule } from './appeals-routing.module';
import { AppealsMainComponent } from './components/main/appeals-main.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { IncorrectDataFormComponent } from './components/incorrect-data-form/incorrect-data-form.component';
import { NewObjectFormComponent } from './components/new-object-form/new-object-form.component';
import { SuccessModalDialogComponent } from './components/success-modal-dialog/success-modal-dialog.component';
import { AppealsService } from './services/appeals.service';
import { CatalogItemCardInfoModule } from '../../../data/shared/components/catalog-item-card-info/catalog-item-card-info.module';
import { NgxMaskDirective, provideEnvironmentNgxMask } from "ngx-mask";

@NgModule({
  declarations: [AppealsMainComponent, ContactInformationComponent, IncorrectDataFormComponent, NewObjectFormComponent, SuccessModalDialogComponent],
  imports: [
    CommonModule,
    AppealsRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CatalogItemCardInfoModule,
    SvgModule,
    FormArrayGroupModule,
    LoaderModule,
    NgLetModule,
    MapModule,
    FormsModule,
    MatTooltipModule,
    MatSelectModule,
    TranslateModule,
    ImpairedIconModule,
    ImpairedInputModule,
    PxModule,
    CaptchaModule,
    NgxMaskDirective
  ],
  providers: [AppealsService, provideEnvironmentNgxMask()]
})
export class AppealsModule {}
